import I18N from '@tencent/i18n';
import dict from './dict.json';
var i18n = new I18N(dict);
export default i18n;
//# sourceMappingURL=index.js.map